<template>
	<div
		v-html="require('!html-loader!./../../svg/' + this.directory + '/'+ this.icon + '.svg')"
		class="svg-container"
	/>
</template>
<style lang="scss" scoped>
.svg-container {
	display: inline-flex;
}
</style>
<script>
export default {
	props: ['icon', 'set'],
	data() {
		return {
			directory: this.set || 'icons',
		};
	},
	mounted() {
		this.$el.firstElementChild.classList.add('w-full', 'h-full');
	}
}
</script>
